export const Modals = {
  P2PUploadModal: 'p2p-upload',
  AssignContactListModal: 'assign-contact-lists',
  ViewTrackedLinksModal: 'view-tracked-links',
  AddTrackedLinkModal: 'add-tracked-link',
  AssignAgentsModal: 'assign-agents',
  AssignJobsModal: 'assign-jobs',
  CreateNewAgent: 'create-new-agent',
  AssignSuppressionListsModal: 'assign-suppression-lists',
  MediaViewerModal: 'media-viewer',
  MediaUploadModal: 'media-upload',
  JobTestModal: 'job-test',
  ReplyTemplateModal: 'reply-template',
  QuestionModal: 'question-modal',
  RequestCanvassersModal: 'request-canvassers',
  AddOptOutModal: 'add-opt-out',
  ContactListDetailsModal: 'contact-list-details',
  CanvasserDetailsModal: 'canvasser-details',
  UserDetailsModal: 'user-details',
  EditUserDetailsModal: 'edit-user-details',
  AssignUsersModal: 'assign-users',
  CreateAccountUserModal: 'create-account-user',
  AddAccountTransactionModal: 'add-account-transaction',
  DebitTransactionDetailsModal: 'debit-transaction-details',
  ExportReportModal: 'export-report-modal',
};
